import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-authorization-confirm-save',
  templateUrl: './authorization-confirm-save.component.html',
  styleUrl: './authorization-confirm-save.component.scss'
})
export class AuthorizationConfirmSaveComponent implements OnInit {

  model: any = {};
  saved = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    private toastr: ToastrService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<AuthorizationConfirmSaveComponent>,
  ) { }

  ngOnInit(): void {
    this.model.open = true;
  }

  close() {
    this.dialogRef.close(false);
  }

  yes() {
    if (this.data.parent && typeof this.data.parent.save === 'function') {
      this.data.parent.save().subscribe(
        (response) => {
          this.saved = true;

          const successMessage = this.data.state === 'add'
            ? this.translate.instant('flows.modal.authorization_scheme.success.create')
            : this.translate.instant('flows.modal.authorization_scheme.success.save');

          this.toastr.success(
            `${this.translate.instant('flows.modal.authorization_scheme.success.start')} "${this.data.name}" ${successMessage}`
          );

        },
        (error) => {
          console.error('Erro ao salvar:', error);
          this.dialogRef.close(false);
        }
      );
    } else {
      this.dialogRef.close(false);
    }
  }

  closeReload() {
    this.dialogRef.close({ reload: false });
  }
  
  goToFlows() {
    this.router.navigate([this.data.partner, this.data.account, 'snapshot']);
  }

}
